// Short labels for the in-app push banner. Flutter forwards only the FCM data
// map (no title/body), so the banner text is derived from the deep link that
// the backend sets per notification (see NotificationConsts.java).
import { getVisitorStatusView } from './visitorStatus';
export const PUSH_BANNER_FALLBACK_TITLE = 'New notification';

export const PUSH_BANNER_LABELS: Record<string, string> = {
    '/home': 'New update',
    '/member-request': 'New member request',
    '/approval': 'Visitor update',
    '/visitor': 'Visitor update',
    '/maintenance': 'Maintenance update',
    '/subscription': 'Subscription update',
    '/fund': 'Society fund update',
    '/complaint': 'Complaint update',
    '/function': 'Event update',
    '/polling': 'Poll update',
    '/election': 'Election update',
    '/vehicles': 'Parking update',
    '/amenities/bookings/mine': 'Amenity booking update',
    '/amenities/requests': 'New amenity booking request',
};

export interface PushBannerContent {
    title: string;
    body: string;
}

export const getPushBannerContent = (deepLink: string, extra: any): PushBannerContent => {
    const title = PUSH_BANNER_LABELS[deepLink] ?? PUSH_BANNER_FALLBACK_TITLE;
    if (deepLink === '/visitor' || deepLink === '/approval') {
        const baseName = extra?.name || extra?.visitorName;
        const name = baseName && extra?.visitorKind ? `${baseName} (${extra.visitorKind})` : baseName;
        const raw = String(extra?.status || '').toUpperCase();
        // Visitor pushes are about walk-ins unless the payload says otherwise.
        const status = raw ? getVisitorStatusView(raw, extra?.source ?? 'GUARD').label : '';
        const flat = extra?.wingName && extra?.homeNo ? `${extra.wingName}-${extra.homeNo}` : '';
        if (name && status) return { title: `${name} — ${status}`, body: flat ? `Home ${flat}` : '' };
        if (status) return { title: `Visitor — ${status}`, body: '' };
        if (name) return { title, body: String(name) };
    }
    return { title, body: '' };
};

/**
 * Banner for a ring push that reaches an account signed in as a guard (Visitor Flows
 * rule 3): guards never get the resident popup. Until Step 3 adds the flat to the
 * payload this reads "{name} is waiting at the gate".
 */
export const getGuardRingBannerContent = (extra: any): PushBannerContent => {
    const name = extra?.visitorName || extra?.name || 'A visitor';
    const wing = extra?.wingName ? String(extra.wingName) : '';
    const home = extra?.homeNo ? String(extra.homeNo) : '';
    const flat = wing && home ? `${wing}-${home}` : '';
    return flat
        ? { title: `${name} is waiting for ${flat}`, body: 'Your home · answer from your resident login' }
        : { title: `${name} is waiting at the gate`, body: 'Your home · answer from your resident login' };
};
